import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import PdfInfoIcon from 'Views/Pages/Pdf/Components/PDFInfoIcon';

interface PdfWarningBannerProps {
	title: string,
	description: string,
}

const PdfWarningBanner = (props: PdfWarningBannerProps) => {
	const {
		title,
		description,
	} = props;

	return (
		<View
			style={{
				display: 'flex',
				flexDirection: 'row',
				columnGap: 4,
				flexWrap: 'wrap',
				color: '#720017',
			}}
			wrap={false}
		>
			<PdfInfoIcon />
			<Text style={{ fontWeight: 'bold' }}>{title}</Text>
			<Text>{description}</Text>
		</View>
	);
};

export default PdfWarningBanner;
